import { heroEquipment } from "../HeroEquipment";

// Source: Warheim.docx, Gang przemytników; priest equipment and skills: chapter 23.
export const gangPrzemytnikow = {
  heroes: {
    "Herszt gangu": {
      id: 0,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca", "Zasadzka"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    "Kapłan Ranalda": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"]["Kapłan Ranalda"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Duchowny (modlitwy do Ranalda)",
        "Gadanina",
        "Modlitwa",
        "Rewelator",
        "Rozproszenie magii (2)",
        "Wzgardzony",
      ],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    "Kapłan Mananna": {
      id: 2,
      startingEquipment: ["Sztylet", "Trójząb"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"]["Kapłan Mananna"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarostwo",
        "Duchowny (modlitwy do Mananna)",
        "Modlitwa",
        "Pogarda",
        "Rozproszenie magii (2)",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    Reketer: {
      id: 3,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Gang przemytników"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Niepokojący"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Paser: {
      id: 4,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Handlarz", "Żyłka handlowa"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Przemytnik: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      // No separate cap (0+ in the rulebook); the army has a 15-model limit.
      number: 15,
      equipmentList: heroEquipment["Gang przemytników"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Przemytnik", "Zasadzka"],
    },
    Doker: {
      id: 6,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Gang przemytników"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Siłacz"],
    },
    Nożownik: {
      id: 7,
      startingEquipment: ["Sztylet", "Broń miotana (noże)"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Gang przemytników"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Nożownik"],
    },
    Rozbójnik: {
      id: 8,
      startingEquipment: ["Sztylet", "Miecz", "Pistolet", "Koń bojowy", "Siodło & uprząż"],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Gang przemytników"].Rozbójnik,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Rajtar", "Zasadzka"],
    },
    Ogr: {
      id: 9,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Gang przemytników"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    "Wóz przemytniczy": {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Wóz przemytniczy"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Gang przemytników",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (2)", "Podatek", "Raubritterzy", "Rozrzutność"],
  mercenaries: [
    "Balistyk", "Bombardier", "Czarownica", "Gladiator", "Kartograf", "Kupiec",
    "Magus", "Medyk", "Minstrel", "Miotacz ołowiu", "Ochroniarz", "Pogromca Trolli",
    "Rycerz najemny", "Skryba", "Szczurołap", "Szpieg", "Tileański kusznik", "Trefniś",
    "Woźnica", "Wróżbita", "Złodziej", "Zwiadowca",
  ],
};
